import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { HttpEventType, HttpEvent } from '@angular/common/http';

import { Observable } from 'rxjs';
import { DocumentService } from 'src/app/_services/document.services';
import { MatTableDataSource } from '@angular/material/table';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UsersAndGroupsService } from 'src/app/_services/users-and-groups.service';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { User } from 'src/app/_models';
import { AppConfig } from 'src/assets/config/config/app-config';
import { formatDate } from '@angular/common';
import { SelectionModel } from '@angular/cdk/collections';
import { FileInboxVirtualFolderService } from 'src/app/_services/fileInbox-virtualFolder.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { FileInboxDynamicForms } from './fileinbox-dynamic-forms/fileinbox-dynamic-forms.component';

@Component({
  selector: 'app-dialog-capture-upload',
  templateUrl: './dialog-capture-upload.component.html',
  styleUrls: ['./dialog-capture-upload.component.scss']
})
export class DialogCaptureUploadComponent implements OnInit {

  noDocuments: any;
  checkFolders: any;
  // folders: any;
  navBarFolders: any[];
  filterValue: string;
  url: string;
  folderDetails: any;
  folders = [];
  selectedFolderName: any;
  selectedFolderId: any;
  folderSelected: boolean = false;
  isMainPage: boolean = false;
  isCreateFolder: boolean = false;
  isCreateSubFolder: boolean = false;
  isUpdateFolder: boolean = false;
  currentUser: User;
  documents: any;
  totalDocumentCount: number = 0;
  offset: number = 0;
  selectedDoc: String;
  loadNext: boolean = false;
  loadPrevious: boolean = false;
  documentCount: number = 0;
  docResultsList: MatTableDataSource<any>;
  selection = new SelectionModel<any>(true, []);
  folderCreated: any;
  //private ithService:ImageTrustService
  width = '100';
  selectedRow: Array<JSON> = [];
  hideDocList: Boolean = false;
  iframeUrl = null;
  loading = false;
  displayImageTrust = false;
  allVirtualFolders
  noFolders:boolean = false;
  fileUploaded: boolean = false;
  azureHeader: any
  docsList: MatTableDataSource<any>;
  docId: string;
  isFile: boolean = false;
  fileToUpload: FileList = null;
  filesToUpload: FileList[] = null;
  progressInfos = [];
  uploadedFiles = []
  fileInfos: Observable<any>;
  message = '';
  refreshClue: any = null;
  searchCtrl: string = "";
  isDocumentUploaded: boolean = false;
  documentCols = ["File Name", "Size", "Type", "Path", "actions"]
  deactivateUpload: boolean = false;
  fileLoading: boolean = false
  allUsers = [];
  allGroups = [];
  allOwners = [];
  selectedUser: string
  user: any;
  userGroups: any[]
  multiparts: any[]
  isDjango: boolean
  docMetadataForm: FormGroup
  waterRightId: string = ""
  placeHolderUUID: string = ""
  selectedFolderPath: string = ""
  isValidData: boolean = false;
  isErrorOnMetadata: boolean = false;
  metadataErrorMessage = '';
  @ViewChild('dynamicForm', {static: false}) dynamicForm: FileInboxDynamicForms;
  IDObject: any;

  constructor(
    public dialogRef: MatDialogRef<DialogCaptureUploadComponent>,
    private documentService: DocumentService,
    private usersAndGroupsService: UsersAndGroupsService,
    private groupService: UsersAndGroupsService,
    private authService: AuthenticationService,
    private virtualFolderService: FileInboxVirtualFolderService,
    private config: AppConfig,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder    
  ) {
    this.userGroups = this.authService.userGroupsValue
    this.currentUser = this.authService.currentUserValue
    this.isDjango = this.config.getConfig('isDjango')
    this.selectedFolderName = data['folderName'];
    this.selectedFolderId = data['folderId'];
    this.selectedFolderPath = data['folderPath'];
    this.docMetadataForm = this.fb.group({
      waterRightId: ['', Validators.required]      
    })
  }

  @ViewChild('fileInput') fileInput: ElementRef;

  openFileBrowser() {
    this.fileInput.nativeElement.click();
  }

  ngOnInit() {    
    if (this.currentUser != null) {
      this.selectedUser = this.currentUser.username
    }    
  }

  close() {
    this.dialogRef.close()
  }


  handleFileInput(event) {
    this.progressInfos = [];
    this.fileToUpload = event.target.files;
    this.isDocumentUploaded = true;    
    this.uploadDocument();
  }

  uploadDocument() {
    this.fileUploaded = false;
    for (let i = 0; i < this.fileToUpload.length; i++) {      
      var fileList = new FormData()
      var systemProperties = null;
      var uploadReq = null;
      systemProperties = {
        "fileName": this.fileToUpload[i].name,
        "size": (this.fileToUpload[i].size),
        "type": this.fileToUpload[i].type
      }
      //build object to be sent to the service
      uploadReq = {
        "owner": this.selectedUser,
        "file_name": this.fileToUpload[i].name,
        "system_properties": systemProperties
      }
      let webPath = this.fileToUpload[i]['webkitRelativePath'];
      let pathArray = webPath.split("/");
      let fullPath = '';
      if (pathArray.length > 1) {
        for (let i = 0; i < pathArray.length - 1; i++) {
          fullPath += pathArray[i] + '/';
        }
        fullPath = fullPath.substring(0, fullPath.length - 1);
      } else {
        fullPath = webPath;
      }
      this.uploadedFiles.push({ value: 0, file: this.fileToUpload[i], fileName: this.fileToUpload[i].name, size: this.fileToUpload[i].size, dataType: this.fileToUpload[i].type, path: fullPath })      
      this.docsList = new MatTableDataSource(this.uploadedFiles);
      this.progressInfos[i] = { value: 0, fileName: this.fileToUpload[i].name, size: this.fileToUpload[i].size };
    }
  }

  async uploadCaptureDocument() {

    console.log("This is the sected user", this.selectedUser)
    if (!this.dynamicForm) {
      this.dynamicForm = new FileInboxDynamicForms(this.virtualFolderService, this.documentService);
    }
    console.log("DOC LIST", this.docsList)
    
    if (this.IDObject && this.IDObject['operation_name'] == 'WR_ID') {
      this.waterRightId = this.IDObject.value;
      let response = await this.dynamicForm.performValidation(this.IDObject);
      if (!response) {
        return;
      }
    }
    if (this.IDObject && this.IDObject['operation_name'] == 'P_UUID') {
      this.placeHolderUUID = this.IDObject.value;
      let response = await this.dynamicForm.performValidation(this.IDObject);
      if (!response) {
        return;
      }
    }
    this.fileUploaded = false;
    var currDate = formatDate(new Date(), 'yyyy/MM/dd', 'en');
    for (let i = 0; i < this.uploadedFiles.length; i++) {
      var systemProperties = null;
      var uploadReq = null;
      systemProperties = {
        "fileName": this.uploadedFiles[i].fileName,
        "size": (this.uploadedFiles[i].size),
        "type": this.uploadedFiles[i].dataType
      }

      let wrIds = [];
      if (this.waterRightId) {
        this.waterRightId = this.waterRightId.trim();
        let wrList = this.waterRightId.split(",");
        for (var index in wrList) {
          wrIds.push(wrList[index]);
        }
      }
      var metadata = {
        "Water Right ID": wrIds,
        "Placeholder UUID": this.placeHolderUUID
      }

      var keyPath = this.selectedUser + "/" + currDate + "/" + this.selectedFolderPath + this.uploadedFiles[i].path;
      if (keyPath.endsWith("/")) {
        keyPath = keyPath.substring(0, keyPath.length - 1);
      }
      //build object to be sent to the service
      uploadReq = {
        "owner": this.selectedUser,
        "file_name": this.uploadedFiles[i].fileName,
        "storageKey": keyPath,
        "folderName": this.selectedFolderName,
        "folderId": this.selectedFolderId,
        "meta_data": metadata,
        "system_properties": systemProperties
      }

      console.log("PAYLOAD", uploadReq)
      //this.progressInfos[i] = { value: 0, fileName: this.fileToUpload[i].name, size: this.fileToUpload[i].size };
      await this.makeUploadServiceCall(uploadReq, systemProperties, i);
    }
  }
  createMultipartHandler(response) {
    return new Promise<void>((resolve, reject) => {
      var params = new URLSearchParams(response.url);
      var part = params.get("partNumber")
      var Etag = response.headers.get("ETag")
      var obj = { ETag: Etag, PartNumber: parseInt(part) }
      this.multiparts.push(obj)
      resolve()
    })
  }

  removeFile($event, file) {



    const index = this.uploadedFiles.indexOf(file);
    if (index > -1) {
      this.uploadedFiles.splice(index, 1);
    }

    if (this.uploadedFiles.length < 1) {
      this.isDocumentUploaded = false;
    }
    //this.progressInfos.remove(file)
    this.docsList = new MatTableDataSource(this.uploadedFiles);
  }

  makeUploadServiceCall(uploadReq, systemProperties, i) {
    return new Promise((resolve, reject) => {
      this.documentService.captureDocument(uploadReq)
        .subscribe(
          resp => {
            this.message = ''
            this.docId = resp["docId"];
            //console.log("url: " + JSON.parse(JSON.stringify(resp)));
            this.progressInfos[i] = { value: 0, fileName: this.uploadedFiles[i].fileName, size: this.uploadedFiles[i].size };
            if (resp['storageProvider'] == "AWS") {
              console.log(resp);
              if (resp["uploadUrl"].length > 1) {
                console.log("Multipart Upload")
                var uploadId = null
                var key = null
                var start = 0
                var end = 0
                var part = 1.
                const noOfParts = resp["uploadUrl"].length
                resp["uploadUrl"].forEach(url => {
                  if (!uploadId || !key) {
                    var decodedUrl = decodeURIComponent(url)
                    var splitData = decodedUrl.split('?')[0]
                    key = splitData.split("aws.com/")[1]
                    var params = new URLSearchParams(url);
                    uploadId = params.toString().split("&")[0].split("=")[1]
                  }
                  const chunkSize = (5 * 1024 * 1024)
                  end = start + chunkSize
                  if (end > systemProperties.size) {
                    end = systemProperties.size
                  }
                  var chunk = this.uploadedFiles[i].slice(start, start + chunkSize + 1)
                  start = end
                  this.multiparts = []
                  this.documentService.uploadToS3(url, chunk).subscribe(resp => {
                    this.createMultipartHandler(resp).then(() => {
                      part++;
                      if ((part - 1) == noOfParts && noOfParts == this.multiparts.length) {
                        this.multiparts.sort((a, b) => {
                          return a.PartNumber - b.PartNumber;
                        });
                        const request = {
                          uploadId: uploadId,
                          key: key,
                          parts: this.multiparts
                        }
                        this.documentService.completeMultipartUpload(request)
                          .subscribe(
                            (event: HttpEvent<any>) => {
                              if (event.type === HttpEventType.UploadProgress) {
                                this.uploadedFiles[i].value = Math.round(100 * event.loaded / event.total);
                                if (this.uploadedFiles[i].value > 0) {
                                  this.fileLoading = true
                                }
                                if (this.uploadedFiles[i].value === 100) {
                                  this.fileUploaded = true;
                                  if (this.uploadedFiles.length === i + 1) {
                                    this.dialogRef.close(this.fileUploaded);
                                  }

                                }
                              }
                            }
                            ,error=>{
                              this.documentService.revertUpload(this.docId,1,-1).subscribe(response=>{
                                // console.log(response)
                              })
                            }
                          )
                          
                      }
                    })
                  }
                  ,error=>{
                    this.documentService.revertUpload(this.docId,1,-1).subscribe(response=>{
                      // console.log(response)
                    })
                  })
                    

                })
              }
              else
                this.documentService.uploadFileToS3Capture(i, resp["uploadUrl"][0], this.uploadedFiles[i].file)
                  .subscribe(

                    (event: HttpEvent<any>) => {
                      if (event.type === HttpEventType.UploadProgress) {
                        this.uploadedFiles[i].value = Math.round(100 * event.loaded / event.total);
                        if (this.uploadedFiles[i].value > 0) {
                          this.fileLoading = true
                        }
                        if (this.uploadedFiles[i].value === 100) {
                          this.fileUploaded = true;
                          if (this.uploadedFiles.length === i + 1) {
                            this.dialogRef.close(this.fileUploaded);
                          }

                        }
                      }
                    },
                    err => {
                      this.uploadedFiles[i].value = 0;
                      this.message = 'Could not upload the file:' + this.uploadedFiles[i].fileName;
                    });

            }

            else if (resp['storageProvider'] == "Azure") {
              this.azureHeader = resp["azureMetadata"]
              this.documentService.uploadFileToAzureCapture(i, resp["uploadUrl"], this.uploadedFiles[i].file, this.azureHeader)
                .subscribe(

                  (event: HttpEvent<any>) => {
                    if (event.type === HttpEventType.UploadProgress) {
                      this.uploadedFiles[i].value = Math.round(100 * event.loaded / event.total);
                      if (this.uploadedFiles[i].value > 0) {
                        this.fileLoading = true
                      }
                      if (this.uploadedFiles[i].value === 100) {
                        this.fileUploaded = true;
                        if (this.uploadedFiles.length === i + 1) {
                          this.dialogRef.close(this.fileUploaded);
                        }


                      }
                    }
                  },
                  err => {
                    this.uploadedFiles[i].value = 0;
                    this.message = 'Could not upload the file:' + this.uploadedFiles[i].fileName;
                  });

            }
            else if (resp['storageProvider'] == "GCP") {
              this.documentService.uploadFileToGCPCapture(i, resp["uploadUrl"], this.uploadedFiles[i].file)
                .subscribe(

                  (event: HttpEvent<any>) => {
                    if (event.type === HttpEventType.UploadProgress) {
                      this.uploadedFiles[i].value = Math.round(100 * event.loaded / event.total);
                      if (this.uploadedFiles[i].value > 0) {
                        this.fileLoading = true
                      }
                      if (this.uploadedFiles[i].value === 100) {
                        this.fileUploaded = true;
                        if (this.uploadedFiles.length === i + 1) {
                          this.dialogRef.close(this.fileUploaded);
                        }

                      }
                    }
                  },
                  err => {
                    this.uploadedFiles[i].value = 0;
                    this.message = 'Could not upload the file:' + this.uploadedFiles[i].fileName;
                  });

            }
            resolve(resp);
          },error => {
            reject(error);
          }
        )
    });
  }

  onClose(): void {
    this.dialogRef.close(this.fileUploaded);
  }

  onFormValue(value: any) {
    this.IDObject = value;
    if (value['operation_name'] == 'WR_ID') {
      this.waterRightId = this.IDObject.value;
    } else {
      this.placeHolderUUID = this.IDObject.value;
    }
  }

  validationCheck(value: boolean) {
    this.isValidData = value;
  }

}
